/**
 * @chineseName 锚点
 * @subDescription m-ui组件 锚点
 */
import Anchor from './Anchor';
import AnchorLink from './AnchorLink';
Anchor.Link = AnchorLink;
export default Anchor;